/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GeoJsonType = {
    Point: 'Point'
} as const;
export type GeoJsonType = typeof GeoJsonType[keyof typeof GeoJsonType];


export function instanceOfGeoJsonType(value: any): boolean {
    for (const key in GeoJsonType) {
        if (Object.prototype.hasOwnProperty.call(GeoJsonType, key)) {
            if (GeoJsonType[key as keyof typeof GeoJsonType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GeoJsonTypeFromJSON(json: any): GeoJsonType {
    return GeoJsonTypeFromJSONTyped(json, false);
}

export function GeoJsonTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoJsonType {
    return json as GeoJsonType;
}

export function GeoJsonTypeToJSON(value?: GeoJsonType | null): any {
    return value as any;
}

export function GeoJsonTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): GeoJsonType {
    return value as GeoJsonType;
}

